import React from 'react';
import PropTypes from 'prop-types';

import CustomLink from '@gc-npm/components.custom-link';
import IconGlyph from '@gc-npm/components.icon-glyph';

import CardContent from './card-content';

export const Card = ({
  data,
  cmsHandler,
  fake,
  screenType,
  carouselMode,
}) => {
  if (!data?.price && !fake) {
    return null;
  }

  // LOGICA ENTORNO PRODUCTIVO
  let tvConfigCardTemplate = (
    <CardContent
      data={data}
      cmsHandler={cmsHandler}
      fake={fake}
      screenType={screenType}
    />
  );

  // LOGICA ENTORNO CMS
  if (cmsHandler) {
    tvConfigCardTemplate = (
      <>
        <button
          type="button"
          className="element-editable block edit-component"
          onClick={() => cmsHandler({
            ...data,
            name: 'cms-block.cms-component-tv-config-card',
          })}
          aria-label="Editar tarjeta"
        >
          <IconGlyph id="lapiz-m" height={20} color="white" />
        </button>
        <CardContent data={data} cmsHandler={cmsHandler} fake={fake} screenType={screenType} />
        <CustomLink
          {...data.linkModal}
          cydata="TvConfigCard CustomLink"
          cmsHandler={cmsHandler}
        />
      </>
    );
  }
  const cssClass = `${data?.logic?.doubleWidth ? 'doubleWidth' : ''} ${carouselMode ? 'carouselCard' : ''}`
  // ejemplo solo para deportes de momento, cambiar por la que benga contribuida con el hardbundle

  return (
    <div id={data.id} className={`tvConfigCard ${cssClass}`}>
      {tvConfigCardTemplate}
      <style jsx>
        {`
      .tvConfigCard{
        min-width: 160px;
        max-width: 160px;
        flex: 1;
        display: flex;
        &.doubleWidth{
          flex-grow: 2;
          min-width: calc(160px + 1rem);
          max-width: calc(320px + 1rem);
        }
        &.carouselCard{
          height: 100%;
          min-width: 288px;
          max-width: 288px;
        }
      }
      @media screen and (max-width: 540px) {
        .tvConfigCard{
          width: calc(50% - 0.25rem);
          min-width: 160px;
          max-width: calc(50% - 0.25rem);
          &.carouselCard{
          min-width: 200px;
          max-width: 200px;
          min-height: 100%;
        }
          &.doubleWidth{
        flex-grow: 2;
        min-width: 100%;
        width: 100%;
        max-width: 100%;
                }
        }
      }
      @media screen and (min-width: 540px) and (max-width: 768px) {
        .tvConfigCard{
          width: calc(33% - 1rem);
          min-width: calc(33% - 1rem);
          max-width: calc(33% - 0.5rem);
          &.carouselCard{
          min-width: 230px;
          max-width: 230px;
          min-height: 100%;
        }
          &.doubleWidth{
            flex-grow: 2;
            min-width: calc(66%);
            max-width: calc(66%);
          }
        }
      }
      @media screen and (max-width: 350px) {
        .tvConfigCard{
          width: 100%;
          min-width: 100%;
          &.doubleWidth{
            flex-grow: 2;
            width: 100%;
                }
        }
      }

      @media screen and (min-width: 768px) {
        .tvConfigCard{
          min-width: 288px;
          max-width: 288px;
          min-height: 223px;
          &.doubleWidth{
            min-width: 288px;
            max-width: 288px;
          }
          &.carouselCard{
          min-width: 288px;
          max-width: 288px;
          min-height: 100%;
        }
          
        }
      }
      @media screen and (min-width: 1365px) {
        .tvConfigCard{
            min-width: 300px;
            max-width: 300px;
          &.doubleWidth{
           min-width: 300px;
           max-width: 300px;
          }
          &.carouselCard{
          min-width: 300px;
          max-width: 300px;
          min-height: 100%;
        }
          
        }
      }
      @media screen and (min-width: 1535px) {
        .tvConfigCard{
            min-width: 322px;
            max-width: 322px;
          &.doubleWidth{
           min-width: 322px;
           max-width: 322px;
          }
          &.carouselCard{
          min-width: 322px;
          max-width: 322px;
          min-height: 100%;
        }
          
        }
      }
        @media screen and (min-width: 1919px) {
        .tvConfigCard{
            min-width: 350px;
            max-width: 350px;
          &.doubleWidth{
           min-width: 350px;
           max-width: 350px;
          }
          &.carouselCard{
          min-width: 350px;
          max-width: 350px;
          min-height: 100%;
        }
          
        }
      }
      
      `}
      </style>
    </div>
  );
}

Card.propTypes = {
  className: PropTypes.string,
  data: PropTypes.object.isRequired,
};

Card.defaultProps = {
  className: '',
};

export default Card;
